"use client";
import React from "react";
import { FormattedMessage } from "@/i18n/i18n-client";
import { EmptyCartIcon } from "@/assets/Icons/EmptyCartIcon";
import { Pagination } from "@/components/Pagination/Pagination";
import { EmptyState } from "@/components/UtilityComponents/EmptyState";
import { Section } from "@/shared/layout";
import type { ShopPageProps } from "../../types";
import LoadingSpinner from "@/shared/globals/UiElements/LoadingSpinner";
import { useSearchParams } from "@/i18n/i18n-navigation";
import { parseSearchParams } from "@/shared/utils/search-params";
import FilterAndSort from "../elements/FilterAndSort";
import ProductsList from "../elements/ProductsList";

const ShopPage: React.FC<ShopPageProps> = ({
  products,
  itemPerPage,
  productsTotalCount,
  offset,
  loading,
}) => {
  const searchParams = useSearchParams();
  const queries = parseSearchParams(searchParams);
  return (
    <>
      <FilterAndSort />

      <Section background="backgroundReverse">
        {loading ? (
          <LoadingSpinner />
        ) : products?.length === 0 ? (
          <EmptyState
            title={
              queries.filters || queries.minPrice || queries.maxPrice ? (
                <FormattedMessage
                  defaultMessage="There are no products match your search criteria"
                  id="i0zpgh"
                />
              ) : (
                <FormattedMessage
                  defaultMessage="There are no products added yet"
                  id="dxKBho"
                />
              )
            }
            image={<EmptyCartIcon />}
          />
        ) : (
          <>
            <ProductsList products={products} />
            <Pagination
              offset={offset}
              itemPerPage={itemPerPage}
              totalCount={productsTotalCount}
              rounded
            />
          </>
        )}
      </Section>
    </>
  );
};

export default ShopPage;
